import { Media } from '@atom/types/media';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';

import classes from './scdotPdfReport.module.css';

interface Props {
  medium: Media;
}

const PhotoBlock = ({ medium }: Props) => {
  return (
    <div className={classes.photoBlock}>
      <div className={classes.photoContainer}>
        <div
          style={{
            backgroundImage: `url('${FILES_ENDPOINT}/${medium?.fileId}_1440')`,
          }}
          className={classes.photo}
        />
      </div>
      <div>{medium?.name}</div>
    </div>
  );
};

export default PhotoBlock;
